'use client';

import { AppBar } from '~/components';
import { useEnvironmentInfo } from '~/hooks';

export default function ProductDetailLayout({ children }: { children: React.ReactNode }) {
  const { isWebview } = useEnvironmentInfo();

  return (
    <>
      {isWebview && <AppBar actions={['home', 'search']} cart />}
      {children}
    </>
  );
}
